import React, { useEffect, useState, useRef } from 'react'
import { fetchPage, prefetchPage, clearPages } from '../../features/pagination/pageCache'
import Floatingbutton from './Floatingbutton'
import Addusersmodal from '../SuperAdminmodal/Addusersmodal'
import Conformationdeleteusermodal from '../SuperAdminmodal/Conformationdeleteusermodal'
import Editusermodal from '../SuperAdminmodal/Editusermodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'
import { useMemo } from 'react'

const Allusers = () => {
  const [showModal, setShowModal] = useState(false)
  const [selectId, setSelectId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [users, setUsers] = useState([])
  // user row currently open in the edit dialog
  const [editUser, setEditUser] = useState(null)
  // id of the newest page request; older responses are ignored so fast
  // clicks on the arrows never show a stale page
  const latestRequest = useRef(0)
  // fresh data on every visit: drop cached pages when leaving this screen
  useEffect(() => () => clearPages(`${config.apiUrl}/user/getUsers`), [])
  const [inputData, setInputData] = React.useState([])
  const [rolls, setRolls] = React.useState([])

  const [pagination, setPagination] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    limit: 0,
    hasNextPage: false,
    hasPrevPage: false
  })

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(() => {
    peginationdata()
  }, [pagination.currentPage, pagination.limit])

  useEffect(() => {
    fetchinputs()
  }, [])

  useEffect(() => {
    fetchrolls()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchrolls()
    }
  }, [showModal])

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchrolls = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/roles/list`, {
        headers: { Authorization: token }
      })

      console.log('ROLES ARRAY:', res.data.data)
      const normalized = (res.data.data || []).map(roll => ({
        rollId: roll.ID,
        rollName: roll.Name
      }))

      setRolls(normalized)
    } catch (err) {
      console.error(err)
      // toast.error('Failed to fetch posts')
    }
  }

  const pageUrl = (page, limit) => `${config.apiUrl}/user/getUsers?page=${page}&limit=${limit}`

  const peginationdata = async () => {
    const token = localStorage.getItem('token')
    const headers = { Authorization: token }
    const requestId = ++latestRequest.current
    try {
      const data = await fetchPage(pageUrl(pagination.currentPage, pagination.limit), headers)
      if (requestId !== latestRequest.current) return
      const res = { data }

      // pre-load the neighbouring pages so the next arrow click is instant
      const p = data.pagination
      if (p) {
        if (p.hasNextPage) prefetchPage(pageUrl(p.currentPage + 1, p.limit), headers)
        if (p.hasPrevPage) prefetchPage(pageUrl(p.currentPage - 1, p.limit), headers)
      }
      const usersData = res.data.data ?? []
      setUsers(
        usersData
          .map(user => ({
            id: user.ID,
            username: user.Name?.trim() || '',
            mobileno: user.MobileNo || '',
            email: user.EmailID || '',
            roleId: user.RoleID ?? null,
            ProjectID: user.ProjectID ?? null,
            Wing: user.Wing ?? null,
            RoomNo: user.RoomNo ?? null,
            LoginMethod: user.LoginMethod?.trim() || '',
            deletedOn: user.DeletedOn
          }))
          .sort((a, b) => b.id - a.id)
      )

      setPagination(prev => ({
        ...prev,
        totalRecords: res.data.pagination?.totalRecords ?? 0,
        totalPages: res.data.pagination?.totalPages ?? 0,
        currentPage: res.data.pagination?.currentPage ?? prev.currentPage,
        limit: res.data.pagination?.limit ?? prev.limit,
        hasNextPage: res.data.pagination?.hasNextPage ?? false,
        hasPrevPage: res.data.pagination?.hasPrevPage ?? false
      }))
    } catch (err) {
      toast.error('Failed to load users')
    }
  }

  const createusers = async payload => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.post(`${config.apiUrl}/user/create`, payload, {
        headers: { Authorization: token }
      })
      const user = res.data.data
      setUsers(prev =>
        [
          {
            id: user.ID,
            username: user.Name?.trim() || '',
            mobileno: user.MobileNo || '',
            email: user.EmailID || '',
            roleId: user.RoleID ?? null,
            ProjectID: user.ProjectID ?? null,
            Wing: user.Wing ?? null,
            RoomNo: user.RoomNo ?? null
          },
          ...prev
        ].sort((a, b) => b.id - a.id)
      )
      clearPages(`${config.apiUrl}/user/getUsers`)
      toast.success('User Created Successfully')
      setShowModal(false)
    } catch (e) {
      console.log('Error creating user', e)
      toast.error('User Already Created')
    }
  }

  const handleConfirmDelete = async () => {
    if (!deleteId) return

    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/user/delete/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      clearPages(`${config.apiUrl}/user/getUsers`)
      await peginationdata()

      setUsers(prev => prev.filter(user => user.id !== deleteId))

      toast.success('User deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete user')
    }
  }

  // Move immediately; arrow state is derived from page numbers so several
  // quick clicks each advance a page without waiting for the server
  const goPrevious = () => {
    setPagination(prev => {
      if (prev.currentPage <= 1) return prev
      const currentPage = prev.currentPage - 1
      return { ...prev, currentPage, hasPrevPage: currentPage > 1, hasNextPage: currentPage < prev.totalPages }
    })
  }

  const goNext = () => {
    setPagination(prev => {
      if (prev.currentPage >= prev.totalPages) return prev
      const currentPage = prev.currentPage + 1
      return { ...prev, currentPage, hasPrevPage: currentPage > 1, hasNextPage: currentPage < prev.totalPages }
    })
  }

  const handleRowsPerPageChange = e => {
    setPagination(prev => ({
      ...prev,
      limit: parseInt(e.target.value),
      currentPage: 1
    }))
  }

  const startRow = (pagination.currentPage - 1) * pagination.limit + 1
  const endRow = Math.min(
    pagination.currentPage * pagination.limit,
    pagination.totalRecords
  )

  const projectMap = useMemo(() => {
    const map = {}
    inputData.forEach(item => {
      if (!map[item.projectId]) {
        map[item.projectId] = item.projectName
      }
    })
    return map
  })
  console.log(projectMap)

  const RollsName = useMemo(() => {
    const rollmap = {}
    rolls.forEach(item => {
      if (!rollmap[item.rollId]) {
        rollmap[item.rollId] = item.rollName
      }
    })
    return rollmap
  })
  console.log(RollsName)

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleUserSaved = saved => {
    if (!saved) return
    clearPages(`${config.apiUrl}/user/getUsers`)
    setUsers(prev =>
      prev.map(u =>
        u.id === saved.ID
          ? {
              ...u,
              username: saved.Name?.trim() || '',
              mobileno: saved.MobileNo || '',
              email: saved.EmailID || '',
              roleId: saved.RoleID ?? null,
              ProjectID: saved.ProjectID ?? null,
              Wing: saved.Wing ?? null,
              RoomNo: saved.RoomNo ?? null,
              LoginMethod: saved.LoginMethod?.trim() || ''
            }
          : u
      )
    )
  }

  const handleDeleteModal = id => {
    setDeleteId(id)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  return (
    <div id="app-Capsule">
      <div className="pt-4">
        <div className="table-responsive-sm pt-5">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center text-bold fs-6">Sr.No</th>
                <th className="text-center text-bold fs-6">Name</th>
                <th className="text-center text-bold fs-6">Mobile No</th>
                <th className="text-center text-bold fs-6">Email ID</th>
                {/* <th className="text-center fs-6 text-bold">Project ID</th> */}
                <th className="text-center fs-6 text-bold">Roll ID</th>
                {/* <th className="text-center fs-6 text-bold">Wing</th> */}
                <th className="text-center fs-6 text-bold">Bldg No./ FlatNo</th>
                 <th className="text-center fs-6 text-bold">Login Method</th>
                <th className="text-center fs-6 text-bold">Edit</th>
                <th className="text-center fs-6 text-bold">Delete User</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id}
                  className="text-center"
                  style={{
                    cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                    // color: user.deletedOn ? 'red' : 'inherit',
                    background: user.deletedOn ? 'rgb(220 220 220)' : 'inherit'
                  }}
                >
                  <th scope="row">{startRow + index}</th>
                  <td className='text-bold'>{user.username}</td>
                  <td className='text-bold'>{user.mobileno}</td>
                  <td className='text-bold'>{user.email}</td>
                  {/* <th>{projectMap[user.ProjectID] || '—'}</th> */}
                  <th>{RollsName[user.roleId] || '—'}</th>
                  {/* <th>{user.Wing}</th> */}
                  <th>{user.RoomNo}</th>
                  <th>{user.LoginMethod}</th>
                  <th>
                    <button
                      type="button"
                      className="btn btn-icon btn-sm mx-auto"
                      onClick={() => setEditUser(user)}
                      disabled={!!user.deletedOn}
                      aria-label={`Edit ${user.username || 'user'}`}
                      title="Edit user"
                    >
                      <ion-icon name="create-outline" aria-hidden="true"></ion-icon>
                    </button>
                  </th>
                  <th>
                    <div
                      className="rounded-circle"
                      style={{
                        backgroundColor: 'red',
                        width: '30px',
                        height: '30px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        cursor: user.deletedOn ? 'not-allowed' : 'pointer',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: 'auto',
                        filter: user.deletedOn ? 'blur(2px)' : 'none',
                        opacity: user.deletedOn ? 0.5 : 1
                      }}
                      onClick={() => {
                        if (!user.deletedOn) {
                          handleDeleteModal(user.id)
                        }
                      }}
                    >
                      <ion-icon
                        name="trash"
                        style={{ fontSize: '15px', color: 'white' }}
                      />
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-center"style={{
        paddingBottom: "5rem",
        paddingTop: "1rem"
      }}>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goPrevious}
            disabled={!pagination.hasPrevPage}
          >
            &lt;
          </button>

          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={goNext}
            disabled={!pagination.hasNextPage}
          >
            &gt;
          </button>

          <span className="fw-medium mx-2">
            Page <strong>{pagination.currentPage}</strong> of{' '}
            <strong>{pagination.totalPages}</strong>
          </span>

          <div className="d-flex align-items-center gap-2">
            <span>Show</span>
            <select
              className="form-select form-select-sm"
              value={pagination.limit}
              onChange={handleRowsPerPageChange}
              style={{ width: '80px' }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="30">30</option>
            </select>
          </div>
        </div>

        {/* <div className="text-muted small" style={{ paddingLeft: '12px' }}>
          Showing <strong>{startRow}</strong> to <strong>{endRow}</strong> of{' '}
          <strong>{pagination.totalRecords}</strong> Rows
        </div> */}
      </div>

      <Floatingbutton onOpen={() => setShowModal(true)} />
      <Addusersmodal
        show={showModal}
        userId={selectId}
        createusers={createusers}
        fetchinputs={fetchinputs}
        inputData={inputData}
        rolls={rolls}
        onClose={() => setShowModal(false)}
      />
      <Editusermodal
        show={!!editUser}
        user={editUser}
        rolls={rolls}
        inputData={inputData}
        onClose={() => setEditUser(null)}
        onSaved={handleUserSaved}
      />
      <Conformationdeleteusermodal
        show={showConfirmModal}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </div>
  )
}

export default Allusers
